<template>
    <b-tab :title="langTitle" active>
        <b-form-group>
            <b-row>
                <b-form-group class="col-md-6" label-for="edit_form_path">
                    <template v-slot:label>
                        <span key="lang_form_path">File Name</span>
                    </template>
                    <template v-slot:description>
                        <span key="lang_form_path_desc">The relative path of the file in the station's media directory.</span>
                    </template>
                    <b-form-input type="text" id="edit_form_path" v-model="form.path.$model"
                                  :state="form.path.$dirty ? !form.path.$error : null"></b-form-input>
                    <b-form-invalid-feedback>
                        <span key="lang_error_required">This field is required.</span>
                    </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group class="col-md-6" label-for="edit_form_title">
                    <template v-slot:label>
                        <span key="lang_form_title">Song Title</span>
                    </template>
                    <b-form-input type="text" id="edit_form_title" v-model="form.title.$model"
                                  :state="form.title.$dirty ? !form.title.$error : null"></b-form-input>
                </b-form-group>
                <b-form-group class="col-md-6" label-for="edit_form_artist">
                    <template v-slot:label>
                        <span key="lang_form_artist">Song Artist</span>
                    </template>
                    <b-form-input type="text" id="edit_form_artist" v-model="form.artist.$model"
                                  :state="form.artist.$dirty ? !form.artist.$error : null"></b-form-input>
                </b-form-group>
                <b-form-group class="col-md-6" label-for="edit_form_genre">
                    <template v-slot:label>
                        <span key="lang_form_genre">Song Genre</span>
                    </template>
                    <b-form-input type="text" id="edit_form_genre" v-model="form.genre.$model"
                                  :state="form.genre.$dirty ? !form.genre.$error : null"></b-form-input>
                </b-form-group>
                <b-form-group class="col-md-6" label-for="edit_form_album">
                    <template v-slot:label>
                        <span key="lang_form_album">Song Album</span>
                    </template>
                    <b-form-input type="text" id="edit_form_album" v-model="form.album.$model"
                                  :state="form.album.$dirty ? !form.album.$error : null"></b-form-input>
                </b-form-group>
                <b-form-group class="col-md-6" label-for="edit_form_lyrics">
                    <template v-slot:label>
                        <span key="lang_form_lyrics">Song Lyrics</span>
                    </template>
                    <b-form-textarea id="edit_form_lyrics" v-model="form.lyrics.$model"
                                     :state="form.lyrics.$dirty ? !form.lyrics.$error : null"></b-form-textarea>
                </b-form-group>
                <b-form-group class="col-md-6" label-for="edit_form_isrc">
                    <template v-slot:label>
                        <span key="lang_form_isrc">ISRC</span>
                    </template>
                    <template v-slot:description>
                        <span key="lang_form_isrc_desc">International Standard Recording Code, used for licensing reports.</span>
                    </template>
                    <b-form-input type="text" id="edit_form_isrc" v-model="form.isrc.$model"
                                  :state="form.isrc.$dirty ? !form.isrc.$error : null"></b-form-input>
                </b-form-group>
            </b-row>
        </b-form-group>
    </b-tab>
</template>

<script>
export default {
    name: 'MediaFormBasicInfo',
    props: {
        form: Object
    },
    computed: {
        langTitle () {
            return 'Basic Information';
        }
    }
};
</script>
